import { SUPPORT_EMAIL_ID } from "constants/common";

const CONTACT_MAIL = `mailto:${SUPPORT_EMAIL_ID}`;

export default function Help(props) {
  return <a href={CONTACT_MAIL}>{props.text}</a>;
}
